<template>
  <div class="rec-risk-container">
    <!-- 背景装饰 -->
    <div class="leftSider">
      <img src="@assets/leftSider.png" alt="">
    </div>
    <div class="rightSider">
      <img src="@assets/rightSider.png" alt="">
    </div>

    <!-- Header -->
    <dp-header :title="'递归域名解析监控（101.7.7.7/101.7.8.9）'"></dp-header>

    <div class="page-update-time">数据更新时间：{{ currentDateText }}</div>

    <div class="org-search-panel">
      <el-input
            v-model="orgSearchKeyword"
            placeholder="输入机构名称查询（支持模糊匹配）"
            size="small"
            clearable
            @keyup.enter.native="handleOrgSearch"
            @clear="backToOverview"
          >
            <el-button slot="append" icon="el-icon-search" @click="handleOrgSearch" />
      </el-input>
      <el-button
        v-if="hasOrgSearched"
        class="back-overview-btn"
        size="small"
        type="warning"
        icon="el-icon-back"
        @click="backToOverview"
      >返回总览</el-button>
    </div>

    <!-- 主要内容区域 -->
    <div class="main-content">
      <!-- 左侧：递归服务器运行状态 / 机构域名概览 -->
      <div class="left-section">
        <!-- 总览模式 -->
        <div v-if="!hasOrgSearched" class="section-card">
          <div class="card-title">递归服务器运行状态</div>
          <div v-if="overviewStatsRangeText" class="stat-range-tip">{{ overviewStatsRangeText }}</div>

          <!-- 状态表格容器 -->
          <div class="status-table-wrapper">
            <el-table
              :data="serverStatusTable"
              style="width: 100%"
              class="status-table"
            >
              <el-table-column prop="metric" label="指标名" width="40%"></el-table-column>
              <el-table-column prop="current" label="本小时" width="30%"></el-table-column>
              <el-table-column prop="avg" label="历史均值" width="30%"></el-table-column>
            </el-table>
          </div>

          <!-- 趋势折线图 -->
          <div class="chart-container trend-chart" ref="trendChart"></div>
        </div>

        <!-- 机构模式：域名概览统计（表格样式） -->
        <div v-else class="section-card">
          <div class="card-title">
            {{ searchedOrgName }} 域名概览
            <span class="subtitle" v-if="orgLoading">（加载中...）</span>
          </div>
          <div v-if="orgOverviewRangeText" class="stat-range-tip">{{ orgOverviewRangeText }}</div>
          <div class="status-table-wrapper org-mode-table-wrapper">
            <el-table :data="orgStatsTable" style="width:100%" class="status-table">
              <el-table-column prop="metric" label="统计项" width="60%"></el-table-column>
              <el-table-column prop="value" label="数值" width="40%">
                <template slot-scope="scope">
                  <span :style="scope.row.danger ? 'color:#f5222d;font-weight:bold' : 'color:#1890FF;font-weight:bold'">
                    {{ scope.row.value }}
                  </span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>

      <!-- 中间：解析请求地理分布 / 域名解析量排名 -->
      <div class="center-section">
        <div class="section-card">
          <!-- 总览标题 -->
          <div v-if="!hasOrgSearched" class="card-title">
            解析请求来源分布
          </div>
          <!-- 机构模式标题 -->
          <div v-else class="card-title">{{ searchedOrgName }} 域名解析量排名（Top 15）</div>

          <!-- 地图（总览模式渲染） -->
          <div v-if="!hasOrgSearched" class="map-container" ref="mapContainer"></div>

          <!-- 柱状图（机构模式渲染） -->
          <div v-if="hasOrgSearched" class="chart-container org-query-chart" ref="orgQueryChart"></div>
          <div v-if="hasOrgSearched && orgLoading" class="org-loading-tip">正在加载解析数据...</div>
          <div v-if="hasOrgSearched && !orgLoading && orgDomainTableData.length === 0" class="org-loading-tip">暂无解析数据</div>
        </div>
      </div>

      <!-- 右侧：递归服务器运行状态（响应码） -->
      <div class="right-section">
        <!-- 总览模式：响应状态 + 历史趋势 -->
        <div v-if="!hasOrgSearched" class="section-card">
          <div class="card-title">递归服务器响应状态</div>
          <div v-if="overviewStatsRangeText" class="stat-range-tip">{{ overviewStatsRangeText }}</div>

          <div class="response-table-wrapper">
            <el-table
              :data="responseStatusTable"
              style="width: 100%"
              class="response-table"
            >
              <el-table-column prop="code" label="响应码" width="40%"></el-table-column>
              <el-table-column prop="current" label="本小时" width="30%"></el-table-column>
              <el-table-column prop="avg" label="历史均值" width="30%"></el-table-column>
            </el-table>
          </div>

          <div class="chart-container history-chart" ref="responseHistoryChart"></div>
        </div>

        <!-- 机构模式：机构响应状态统计 -->
        <div v-else class="section-card">
          <div class="card-title">{{ searchedOrgName }} 响应状态统计</div>
          <div v-if="orgResponseRangeText" class="stat-range-tip">{{ orgResponseRangeText }}</div>

          <div class="response-table-wrapper org-mode-table-wrapper">
            <el-table
              :data="orgRespCodeTable"
              style="width: 100%"
              class="response-table"
            >
              <el-table-column prop="code" label="响应码" width="40%"></el-table-column>
              <el-table-column prop="count" label="查询次数" width="30%"></el-table-column>
              <el-table-column prop="percent" label="占比" width="30%"></el-table-column>
            </el-table>
            <div v-if="orgLoading" style="text-align:center;color:rgba(255,255,255,0.5);padding:10px;font-size:12px;">加载中...</div>
            <div v-else-if="orgRespCodeTable.length === 0" style="text-align:center;color:rgba(255,255,255,0.5);padding:10px;font-size:12px;">暂无解析记录</div>
          </div>
        </div>
      </div>

      <!-- 底部：域名劫持事件通报 / 机构域名资产 -->
      <div class="bottom-section">
        <!-- 总览模式：劫持事件通报 -->
        <div v-if="!hasOrgSearched" class="section-card bottom-card">
          <div class="card-title">递归服务器监测到的域名劫持事件通报</div>

          <div class="bottom-content">
            <!-- 左侧：统计信息 -->
            <div class="stats-panel">
              <div class="stats-title">近一个月统计</div>

              <div class="stats-items-wrapper">
                <div class="stats-item">
                  <div class="stats-label">劫持事件</div>
                  <div class="stats-value">
                    <span class="number">{{ hijackStats.eventCount }}</span>
                    <span class="unit">起</span>
                  </div>
                </div>

                <div class="stats-item">
                  <div class="stats-label">涉及域名</div>
                  <div class="stats-value">
                    <span class="number">{{ hijackStats.domainCount }}</span>
                    <span class="unit">个</span>
                  </div>
                </div>

                <div class="stats-item">
                  <div class="stats-label">影响机构</div>
                  <div class="stats-value">
                    <span class="number">{{ hijackStats.orgCount }}</span>
                    <span class="unit">个</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- 右侧：事件表格 -->
            <div class="events-panel">
              <el-table
                ref="hijackEventTable"
                :data="hijackEventData"
                style="width: 100%"
                class="hijack-event-table"
                @mouseenter.native="pauseHijackTableScroll"
                @mouseleave.native="resumeHijackTableScroll"
              >
                <el-table-column prop="time" label="告警时间" min-width="150"></el-table-column>
                <el-table-column prop="domain" label="被劫持域名" min-width="180"></el-table-column>
                <el-table-column label="归属机构" min-width="180">
                  <template slot-scope="scope">
                    <template v-if="scope.row.companiesLoading"><span class="muted">查询中...</span></template>
                    <template v-else-if="(scope.row.companies || []).length">
                      <span v-for="(company, index) in scope.row.companies" :key="index" class="company-tag">{{ company }}</span>
                    </template>
                    <template v-else><span class="muted">—</span></template>
                  </template>
                </el-table-column>
                <el-table-column label="域名归属列表" min-width="160">
                  <template slot-scope="scope">
                    <template v-if="scope.row.listMetadataLoading"><span class="muted">查询中...</span></template>
                    <template v-else-if="formatDomainListMetadata(scope.row.listMetadata) !== '—'">
                      <el-tooltip :content="formatDomainListMetadata(scope.row.listMetadata)" placement="top" :open-delay="200">
                        <span class="list-tags-preview">{{ formatDomainListMetadata(scope.row.listMetadata) }}</span>
                      </el-tooltip>
                    </template>
                    <template v-else><span class="muted">—</span></template>
                  </template>
                </el-table-column>
                <el-table-column label="排名/归属" min-width="130">
                  <template slot-scope="scope">
                    <template v-if="scope.row.listMetadataLoading"><span class="muted">查询中...</span></template>
                    <span v-else>{{ formatBestListRank(scope.row.listMetadata) }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="normalIP" label="劫持前IP" min-width="150"></el-table-column>
                <el-table-column prop="maliciousIP" label="劫持后IP" min-width="150"></el-table-column>
                <el-table-column label="置信度" min-width="110">
                  <template slot-scope="scope">
                    <el-tooltip :content="scope.row.hijackProbText" placement="top" :open-delay="200" effect="dark">
                      <div class="hijack-confidence-bar">
                        <span
                          class="hijack-confidence-fill"
                          :class="scope.row.hijackProbClass"
                          :style="{ width: scope.row.hijackProbWidth }"
                        ></span>
                      </div>
                    </el-tooltip>
                  </template>
                </el-table-column>
                <el-table-column prop="status" label="确认状态" min-width="100">
                  <template slot-scope="scope">
                    <el-tag
                      :type="scope.row.status === '新发现' ? 'danger' : 'success'"
                      size="small"
                    >
                      {{ scope.row.status }}
                    </el-tag>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>

        <!-- 机构模式：域名资产全列表 -->
        <div v-else class="section-card bottom-card">
          <div class="card-title">
            {{ searchedOrgName }} 域名资产
            <span class="subtitle">（共 <span class="highlight">{{ orgStats.domainCount }}</span> 个域名，<span class="highlight hijack-highlight">{{ orgStats.hijackedDomainCount }}</span> 个被劫持）</span>
          </div>
          <el-table
            :data="orgDomainTableData"
            style="width: 100%"
            class="org-domain-table"
            :row-class-name="orgDomainRowClass"
            @row-click="handleOrgDomainClick"
          >
            <el-table-column prop="domain" label="域名" min-width="200"></el-table-column>
            <el-table-column label="归属机构" min-width="180">
              <template slot-scope="scope">
                <template v-if="scope.row.companiesLoading">
                  <span class="muted">查询中...</span>
                </template>
                <template v-else-if="(scope.row.companies || []).length">
                  <span v-for="(c, i) in scope.row.companies" :key="i" class="company-tag">{{ c }}</span>
                </template>
                <template v-else>
                  <span class="muted">-</span>
                </template>
              </template>
            </el-table-column>
            <el-table-column label="劫持状态" min-width="100">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.hijackCount > 0" type="danger" size="small">已劫持</el-tag>
                <el-tag v-else type="success" size="small" effect="plain">正常</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="totalCount" label="总解析量" min-width="110">
              <template slot-scope="scope">{{ formatCount(scope.row.totalCount) }}</template>
            </el-table-column>
            <el-table-column prop="ipCount" label="解析IP数" min-width="90"></el-table-column>
            <el-table-column prop="lastSeen" label="最近解析时间" min-width="160"></el-table-column>
            <el-table-column prop="hijackCount" label="历史劫持次数" min-width="110">
              <template slot-scope="scope">
                <span :style="scope.row.hijackCount > 0 ? 'color:#f5222d;font-weight:bold' : ''">
                  {{ scope.row.hijackCount }} 次
                </span>
              </template>
            </el-table-column>
          </el-table>
          <div v-if="orgLoading" class="org-loading-tip" style="text-align:center;padding:20px;">
            正在查询各域名解析数据，请稍候...
          </div>
        </div>
      </div>
      <div class="beian-footer">
        <a href="https://beian.miit.gov.cn/" target="_blank">鲁ICP备2026032922号-1</a>
        <span>|</span>
        <a
          class="beian-police-link"
          href="https://beian.mps.gov.cn/#/query/webSearch?code=37140202001764"
          rel="noreferrer"
          target="_blank"
        >
          <img class="beian-police-logo" src="/beian-police.png" alt="公安备案" />
          鲁公网安备37140202001764号
        </a>
      </div>
    </div>

    <!-- 域名解析历史弹窗 -->
    <el-dialog
      :title="`${orgSelectedDomain} — 解析历史`"
      :visible.sync="orgDomainDialogVisible"
      :modal="false"
      width="75%"
      class="domain-detail-dialog"
    >
      <el-table :data="orgSelectedFlintData" style="width:100%" class="flint-table">
        <el-table-column prop="response_code" label="响应码" min-width="100"></el-table-column>
        <el-table-column label="解析结果" min-width="220">
          <template slot-scope="scope">
            <span style="white-space:pre-line;">{{ scope.row.answersDisplay }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="count" label="查询次数" min-width="100"></el-table-column>
        <el-table-column prop="first_seen" label="首次见到" min-width="160"></el-table-column>
        <el-table-column prop="last_seen" label="最后见到" min-width="160"></el-table-column>
      </el-table>
      <div v-if="orgSelectedFlintData.length === 0" style="text-align:center;color:rgba(255,255,255,0.5);padding:30px;">
        该域名暂无被动 DNS 解析记录
      </div>
    </el-dialog>

    <!-- 查询加载遮罩 -->
    <div v-if="isOrgLoading" class="loading-overlay">
      <div class="loading-content">
        <div class="loading-dots">
          <span></span><span></span><span></span>
        </div>
        <div class="loading-text">{{ orgLoadingText }}</div>
      </div>
    </div>

    <!-- 底部导航 -->
    <navigation ref="nav" @navChange="handleNavChange"></navigation>
  </div>
</template>

<script>
import * as echarts from "echarts";
import chinaMapData from "@/assets/models/geoJson/china.json";
import { getRegistrableDomain } from "@/utils/domain";
import { formatDomainListMetadata, formatBestListRank } from "@/utils/domainListMetadata";
import {
  getRecQcountTab,
  getRecQcountLine,
  getRecRespstatusTab,
  getRecRespstatusHistory,
  getRecHijkcountTab,
  getRecHijkinfoTab,
  getRecQcountMap,
  queryPassiveDnsFlint,
  getEntityInfo,
  getDomainAuthRiskList,
  getDomainCompanyBatch,
  getDomainListMetadata
} from "@/service/dashboard";

export default {
  name: "RecRisk",
  data() {
    return {
      // 服务器状态表格数据
      serverStatusTable: [],

      // 响应状态表格数据
      responseStatusTable: [],

      // 响应码历史数据（用于计算平均值）
      responseHistoryData: [],

      // 运行状态历史数据（用于标注历史均值范围）
      trendHistoryData: [],

      // 当前响应码数据
      currentResponseData: null,

      // 图表实例
      trendChart: null,
      mapChart: null,
      responseHistoryChart: null,

      // 劫持事件统计
      hijackStats: {
        eventCount: 0,
        domainCount: 0,
        orgCount: 0
      },

      // 劫持事件数据
      hijackEventData: [],

      // 自动刷新定时器
      refreshTimer: null,

      // resize防抖定时器
      resizeTimer: null,

      // 底部劫持事件表格滚动定时器
      hijackTableScrollTimer: null,

      // 底部表格滚动暂停标志
      hijackTableScrollPaused: false,

      // ---- 机构搜索模式 ----
      hasOrgSearched: false,
      orgSearchKeyword: "",
      searchedOrgName: "",
      orgLoading: false,
      isOrgLoading: false,
      orgLoadingText: "",
      orgLoadingTimer: null,
      orgLoadingSteps: [
        "Thinking...",
        "Crawling domain assets...",
        "Analyzing recursive DNS data...",
        "Correlating response signals...",
        "Scanning resolution history...",
        "Evaluating hijack indicators...",
        "Almost there..."
      ],
      orgLoadingStepIndex: 0,
      orgStats: { domainCount: 0, totalQueryCount: 0, activeDomainCount: 0, hijackedDomainCount: 0 },
      orgDomainTableData: [],   // 底部域名资产表格数据
      orgQueryChart: null,       // 中间柱状图实例
      orgSelectedDomain: "",
      orgSelectedFlintData: [],
      orgDomainDialogVisible: false,
      orgDomainFlintMap: {},  // 保存 flint 原始数据供弹窗使用
      orgSelected: false
    };
  },
  computed: {
    overviewStatsRangeText() {
      return this.formatDateRange(
        [
          ...this.trendHistoryData,
          ...this.responseHistoryData
        ],
        "历史均值统计范围"
      );
    },
    orgOverviewRangeText() {
      return this.formatOrgDateRange("统计范围");
    },
    orgResponseRangeText() {
      return this.formatOrgDateRange("统计范围");
    },
    currentDateText() {
      // 与"递归服务器运行状态"的历史均值统计范围保持一致，取该范围的最新（结束）日期
      const range = this.getDateRangeFromRows([
        ...this.trendHistoryData,
        ...this.responseHistoryData
      ]);

      if (range) {
        const parts = range.split("至");

        return parts[parts.length - 1].trim();
      }

      const now = new Date();
      const pad = value => String(value).padStart(2, "0");

      return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
    },
    orgStatsTable() {
      return [
        { metric: "域名总数", value: this.orgStats.domainCount + " 个", danger: false },
        { metric: "总解析量", value: this.formatCount(this.orgStats.totalQueryCount), danger: false },
        { metric: "活跃域名数（近30天）", value: this.orgStats.activeDomainCount + " 个", danger: false },
        { metric: "被劫持域名数", value: this.orgStats.hijackedDomainCount + " 个", danger: this.orgStats.hijackedDomainCount > 0 }
      ];
    },
    orgRespCodeTable() {
      const codeCounts = this.createResponseCodeBuckets();

      let total = 0;

      Object.values(this.orgDomainFlintMap).forEach(records => {
        (records || []).forEach(r => {
          const codeName = this.getPrimaryResponseCodeName(r.response_code);
          const count = r.count || 0;

          codeCounts[codeName] = (codeCounts[codeName] || 0) + count;
          total += count;
        });
      });
      if (total === 0) {
        return [];
      }

      return this.getResponseCodeOrder().map(code => {
        const count = codeCounts[code] || 0;

        return {
          code,
          count: count.toLocaleString(),
          percent: total > 0 ? ((count / total) * 100).toFixed(2) + "%" : "0%"
        };
      });
    }
  },
  mounted() {
    // 使用$nextTick确保DOM完全渲染后再初始化图表
    this.$nextTick(() => {
      // 延迟50ms，等待CSS Grid布局完全稳定
      setTimeout(async () => {
        this.initCharts();
        await this.loadData();

        // 数据加载完成后调用resize，确保图表尺寸正确
        this.$nextTick(() => {
          if (this.trendChart) {
            this.trendChart.resize();
          }
          if (this.mapChart) {
            this.mapChart.resize();
          }
          if (this.responseHistoryChart) {
            this.responseHistoryChart.resize();
          }

          // 启动底部表格自动滚动
          this.startHijackTableScroll();
        });
      }, 50);
    });

    // 添加窗口resize事件监听
    window.addEventListener("resize", this.handleResize);

    // 设置自动刷新（60秒）
    this.refreshTimer = setInterval(() => {
      this.loadData();
    }, 60000);
  },
  beforeDestroy() {
    if (this.trendChart) {
      this.trendChart.dispose();
    }
    if (this.mapChart) {
      this.mapChart.dispose();
    }
    if (this.responseHistoryChart) {
      this.responseHistoryChart.dispose();
    }
    if (this.orgQueryChart) {
      this.orgQueryChart.dispose();
    }
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer);
    }
    if (this.resizeTimer) {
      clearTimeout(this.resizeTimer);
    }
    if (this.hijackTableScrollTimer) {
      clearInterval(this.hijackTableScrollTimer);
    }
    if (this.orgLoadingTimer) {
      clearInterval(this.orgLoadingTimer);
    }
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    normalizeDateValue(value) {
      if (!value) {
        return "";
      }
      if (typeof value === "string") {
        return value.slice(0, 10);
      }
      if (value instanceof Date) {
        return value.toISOString().slice(0, 10);
      }

      return String(value).slice(0, 10);
    },
    getDateRangeFromRows(rows) {
      const dates = (rows || [])
        .flatMap(item => [
          item.date,
          item.day,
          item.stat_date,
          item.statDate,
          item.query_date,
          item.queryDate,
          item.first_seen,
          item.firstSeen,
          item.last_seen,
          item.lastSeen,
          item.created_at,
          item.updated_at,
          item.time
        ])
        .map(value => this.normalizeDateValue(value))
        .filter(Boolean)
        .sort();

      if (!dates.length) {
        return "";
      }

      const start = dates[0];
      const end = dates[dates.length - 1];

      return `${start} 至 ${end}`;
    },
    getRecentDateRange(days = 30) {
      const end = new Date();
      const start = new Date(end.getTime() - (days - 1) * 24 * 60 * 60 * 1000);
      const format = date => date.toISOString().slice(0, 10);

      return `${format(start)} 至 ${format(end)}`;
    },
    formatDateRange(rows, prefix) {
      const range = this.getDateRangeFromRows(rows) || this.getRecentDateRange(30);

      return `${prefix}：${range}`;
    },
    formatOrgDateRange(prefix) {
      const flintRows = Object.values(this.orgDomainFlintMap || {}).flat();
      const tableRows = this.orgDomainTableData || [];
      const range = this.getDateRangeFromRows(flintRows) || this.getDateRangeFromRows(tableRows) || this.getRecentDateRange(30);

      return `${prefix}：${range}`;
    },
    // 处理窗口大小变化（带防抖）
    handleResize() {
      if (this.resizeTimer) {
        clearTimeout(this.resizeTimer);
      }
      this.resizeTimer = setTimeout(() => {
        if (this.trendChart) {
          this.trendChart.resize();
        }
        if (this.mapChart) {
          this.mapChart.resize();
        }
        if (this.responseHistoryChart) {
          this.responseHistoryChart.resize();
        }
        if (this.orgQueryChart) {
          this.orgQueryChart.resize();
        }
      }, 100);
    },
    getResponseCodeOrder() {
      return ["NOERROR", "SERVFAIL", "NXDOMAIN", "其他"];
    },
    getPrimaryResponseCodeName(code) {
      const responseCodeMap = {
        0: "NOERROR",
        1: "FORMERR",
        2: "SERVFAIL",
        3: "NXDOMAIN",
        4: "NOTIMP",
        5: "REFUSED"
      };

      let codeName = responseCodeMap[Number(code)];

      if (!codeName) {
        codeName = String(code || "Unknown")
          .trim()
          .replace(/[\s_-]+/g, "")
          .toUpperCase();
      }

      return this.getResponseCodeOrder().includes(codeName) ? codeName : "其他";
    },
    createResponseCodeBuckets(initialValue = 0) {
      return this.getResponseCodeOrder().reduce((buckets, code) => {
        buckets[code] = initialValue;
        return buckets;
      }, {});
    },
    aggregateResponsePercentRows(codes, values) {
      const buckets = this.createResponseCodeBuckets();

      let hasNumericValue = false;

      (codes || []).forEach((code, index) => {
        const value = parseFloat((values || [])[index]);

        if (Number.isFinite(value)) {
          buckets[this.getPrimaryResponseCodeName(code)] += value;
          hasNumericValue = true;
        }
      });

      return this.getResponseCodeOrder().map(code => ({
        code,
        value: hasNumericValue ? buckets[code].toFixed(2) + "%" : "--"
      }));
    },
    // 初始化图表
    initCharts() {
      echarts.registerMap("china", chinaMapData);
      if (this.$refs.trendChart && !this.trendChart) {
        this.trendChart = echarts.init(this.$refs.trendChart);
      }
      if (this.$refs.mapContainer && !this.mapChart) {
        this.mapChart = echarts.init(this.$refs.mapContainer);
      }
      if (this.$refs.responseHistoryChart && !this.responseHistoryChart) {
        this.responseHistoryChart = echarts.init(this.$refs.responseHistoryChart);
      }
      if (this.$refs.orgQueryChart && !this.orgQueryChart) {
        this.orgQueryChart = echarts.init(this.$refs.orgQueryChart);
      }
    },

    disposeChart(name) {
      if (this[name]) {
        this[name].dispose();
        this[name] = null;
      }
    },

    disposeOverviewCharts() {
      this.disposeChart("trendChart");
      this.disposeChart("mapChart");
      this.disposeChart("responseHistoryChart");
    },

    disposeOrgCharts() {
      this.disposeChart("orgQueryChart");
    },

    // 加载所有数据
    async loadData() {
      // 先加载历史数据，再加载当前数据
      await this.loadResponseHistoryData();

      await Promise.all([
        this.loadServerStatusData(),
        this.loadTrendData(),
        this.loadResponseStatusData(),
        this.loadMapData(),
        this.loadHijackStatsData(),
        this.loadHijackEventsData()
      ]);
    },

    // 加载服务器状态表格数据
    async loadServerStatusData() {
      try {
        const res = await getRecQcountTab();

        if (res.code === 200) {
          const data = res.data;

          this.serverStatusTable = data.指标名.map((metric, index) => ({
            metric: metric,
            current: data.本小时[index],
            avg: data.历史均值[index]
          }));
        }
      } catch (error) {
        console.error("加载服务器状态数据失败", error);
      }
    },

    // 加载趋势数据
    async loadTrendData() {
      try {
        const res = await getRecQcountLine();

        if (res.code === 200) {
          const data = res.data;

          this.trendHistoryData = Array.isArray(data) ? data : [];

          this.updateTrendChart(data);
        }
      } catch (error) {
        console.error("加载趋势数据失败", error);
      }
    },

    // 更新趋势折线图（使用三个独立Y轴）
    updateTrendChart(data) {
      if (!this.trendChart) {
        return;
      }

      const option = {
        tooltip: {
          trigger: "axis",
          formatter: (params) => {
            let result = params[0].axisValueLabel + "<br/>";

            params.forEach(item => {
              const value = item.value[1];
              const formattedValue = value >= 1000000
                ? (value / 1000000).toFixed(2) + "M"
                : value >= 1000
                  ? (value / 1000).toFixed(2) + "K"
                  : value;

              result += `${item.marker} ${item.seriesName}: ${formattedValue}<br/>`;
            });
            return result;
          }
        },
        legend: {
          data: ["解析量", "域名量", "用户量"],
          textStyle: {
            color: "#fff"
          },
          top: 10
        },
        grid: {
          left: "3%",
          right: "8%",
          top: "20%",
          bottom: "15%",
          containLabel: true
        },
        xAxis: {
          type: "time",
          boundaryGap: false,
          axisLine: {
            lineStyle: {
              color: "rgba(255, 255, 255, 0.3)"
            }
          },
          axisLabel: {
            color: "#fff",
            formatter: "{MM}-{dd}"
          }
        },
        yAxis: [
          {
            type: "value",
            name: "解析量",
            position: "left",
            offset: 0,
            axisLine: {
              show: true,
              lineStyle: {
                color: "#1890FF"
              }
            },
            axisLabel: {
              color: "#1890FF",
              formatter: (value) => {
                if (value >= 1000000) {
                  return (value / 1000000).toFixed(0) + "M";
                }
                if (value >= 1000) {
                  return (value / 1000).toFixed(0) + "K";
                }
                return value;
              }
            },
            splitLine: {
              show: false
            }
          },
          {
            type: "value",
            name: "域名量",
            position: "right",
            offset: 0,
            axisLine: {
              show: true,
              lineStyle: {
                color: "#52C41A"
              }
            },
            axisLabel: {
              color: "#52C41A",
              formatter: (value) => {
                if (value >= 1000000) {
                  return (value / 1000000).toFixed(1) + "M";
                }
                if (value >= 1000) {
                  return (value / 1000).toFixed(0) + "K";
                }
                return value;
              }
            },
            splitLine: {
              show: false
            }
          },
          {
            type: "value",
            name: "用户量",
            position: "right",
            offset: 60,
            axisLine: {
              show: true,
              lineStyle: {
                color: "#00D4FF"
              }
            },
            axisLabel: {
              color: "#00D4FF",
              formatter: (value) => {
                if (value >= 1000) {
                  return (value / 1000).toFixed(1) + "K";
                }
                return value;
              }
            },
            splitLine: {
              show: false
            }
          }
        ],
        series: [
          {
            name: "解析量",
            type: "line",
            smooth: true,
            yAxisIndex: 0,
            data: data.解析量,
            itemStyle: {
              color: "#1890FF"
            },
            lineStyle: {
              width: 2
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "rgba(24, 144, 255, 0.3)" },
                { offset: 1, color: "rgba(24, 144, 255, 0.05)" }
              ])
            }
          },
          {
            name: "域名量",
            type: "line",
            smooth: true,
            yAxisIndex: 1,
            data: data.域名量,
            itemStyle: {
              color: "#52C41A"
            },
            lineStyle: {
              width: 2
            }
          },
          {
            name: "用户量",
            type: "line",
            smooth: true,
            yAxisIndex: 2,
            data: data.用户量,
            itemStyle: {
              color: "#00D4FF"
            },
            lineStyle: {
              width: 2
            }
          }
        ]
      };

      this.trendChart.setOption(option);
    },

    // 加载响应状态表格数据
    async loadResponseStatusData() {
      try {
        const res = await getRecRespstatusTab();

        if (res.code === 200 && res.data && res.data.响应码 && res.data.响应码.length > 0) {
          const data = res.data;
          // 先保存当前数据，等历史数据加载后再更新表格

          this.currentResponseData = data;
          this.updateResponseTable();
        } else {
          // 数据为空，不更新currentResponseData，保持使用历史数据
          console.warn("当前响应码数据为空");
        }
      } catch (error) {
        console.error("加载响应状态数据失败", error);
        // 接口失败时不更新currentResponseData，保持使用历史数据
      }
    },

    // 更新响应状态表格（结合当前数据和历史平均值）
    updateResponseTable() {
      // 计算历史平均值
      const historicalAverages = this.calculateHistoricalAverages();

      // 如果当前数据存在，使用当前数据
      if (this.currentResponseData) {
        const data = this.currentResponseData;
        const currentRows = this.aggregateResponsePercentRows(data.响应码, data.本小时);

        this.responseStatusTable = currentRows.map(row => ({
          code: row.code,
          current: row.value,
          avg: historicalAverages[row.code] || "-"
        }));
      } else {
        // 如果当前数据不存在（接口挂了），使用历史数据中的响应码类型
        const responseCodes = this.getResponseCodeOrder();

        if (responseCodes.length > 0) {
          this.responseStatusTable = responseCodes.map(code => ({
            code: code,
            current: "-",
            avg: historicalAverages[code] || "-"
          }));
        }
      }
    },

    // 计算历史平均值
    calculateHistoricalAverages() {
      if (!this.responseHistoryData || this.responseHistoryData.length === 0) {
        return {};
      }

      // 统计每个响应码的总数和出现次数
      const codeStats = this.createResponseCodeBuckets(null);

      this.getResponseCodeOrder().forEach(codeName => {
        codeStats[codeName] = {
          totalPercent: 0,
          count: 0
        };
      });

      this.responseHistoryData.forEach(dayData => {
        // 计算当天的总请求数
        const dayTotal = dayData.response_codes.reduce((sum, rc) => sum + rc.count, 0);
        const dayBuckets = this.createResponseCodeBuckets();

        dayData.response_codes.forEach(rc => {
          dayBuckets[this.getPrimaryResponseCodeName(rc.response_code)] += rc.count;
        });

        this.getResponseCodeOrder().forEach(codeName => {
          const percent = dayTotal > 0 ? (dayBuckets[codeName] / dayTotal) * 100 : 0;

          codeStats[codeName].totalPercent += percent;
          codeStats[codeName].count += 1;
        });
      });

      // 计算平均百分比
      const averages = {};

      Object.keys(codeStats).forEach(codeName => {
        const stats = codeStats[codeName];
        const avgPercent = stats.count > 0 ? stats.totalPercent / stats.count : 0;

        averages[codeName] = avgPercent.toFixed(2) + "%";
      });

      return averages;
    },

    // 加载响应码历史趋势数据
    async loadResponseHistoryData() {
      try {
        const res = await getRecRespstatusHistory();

        if (res.code === 200) {
          this.responseHistoryData = res.data;
          this.updateResponseHistoryChart(res.data);
          // 历史数据加载完成后，更新表格的平均值
          this.updateResponseTable();
        }
      } catch (error) {
        console.error("加载响应码历史数据失败", error);
      }
    },

    // 更新响应码历史趋势图
    updateResponseHistoryChart(data) {
      if (!this.responseHistoryChart || !data || data.length === 0) {
        return;
      }

      // 响应码颜色映射
      const colorMap = {
        "NOERROR": "#52C41A",
        "SERVFAIL": "#FA8C16",
        "NXDOMAIN": "#FAAD14",
        "其他": "#8C8C8C"
      };

      // 提取所有日期
      const dates = data.map(item => item.date);

      // 为每个响应码创建系列数据
      const series = [];

      this.getResponseCodeOrder().forEach(codeName => {
        const seriesData = dates.map(date => {
          const dayData = data.find(d => d.date === date);

          if (dayData) {
            return dayData.response_codes.reduce((sum, rc) => {
              return this.getPrimaryResponseCodeName(rc.response_code) === codeName
                ? sum + rc.count
                : sum;
            }, 0);
          }
          return 0;
        });

        series.push({
          name: codeName,
          type: "line",
          smooth: true,
          data: seriesData,
          itemStyle: {
            color: colorMap[codeName] || "#1890FF"
          },
          lineStyle: {
            width: 2
          },
          areaStyle: {
            opacity: 0.3
          }
        });
      });

      const option = {
        tooltip: {
          trigger: "axis",
          formatter: (params) => {
            let result = params[0].axisValueLabel + "<br/>";

            params.forEach(item => {
              const value = item.value;
              const formattedValue = value >= 1000000
                ? (value / 1000000).toFixed(2) + "M"
                : value >= 1000
                  ? (value / 1000).toFixed(2) + "K"
                  : value;

              result += `${item.marker} ${item.seriesName}: ${formattedValue}<br/>`;
            });
            return result;
          }
        },
        legend: {
          data: this.getResponseCodeOrder(),
          textStyle: {
            color: "#fff"
          },
          top: 10
        },
        grid: {
          left: "3%",
          right: "5%",
          top: "20%",
          bottom: "15%",
          containLabel: true
        },
        xAxis: {
          type: "category",
          data: dates,
          boundaryGap: false,
          axisLine: {
            lineStyle: {
              color: "rgba(255, 255, 255, 0.3)"
            }
          },
          axisLabel: {
            color: "#fff",
            formatter: (value) => {
              // 格式化日期显示
              const date = new Date(value);

              return `${date.getMonth() + 1}-${date.getDate()}`;
            }
          }
        },
        yAxis: {
          type: "value",
          name: "请求数",
          axisLine: {
            show: true,
            lineStyle: {
              color: "rgba(255, 255, 255, 0.3)"
            }
          },
          axisLabel: {
            color: "#fff",
            formatter: (value) => {
              if (value >= 1000000) {
                return (value / 1000000).toFixed(0) + "M";
              }
              if (value >= 1000) {
                return (value / 1000).toFixed(0) + "K";
              }
              return value;
            }
          },
          splitLine: {
            lineStyle: {
              color: "rgba(255, 255, 255, 0.1)"
            }
          }
        },
        series: series
      };

      this.responseHistoryChart.setOption(option);
    },

    // 加载地图数据
    async loadMapData() {
      try {
        const res = await getRecQcountMap();

        if (res.code === 200) {
          const data = res.data;
          const mapData = Object.keys(data).map(province => ({
            name: province,
            value: data[province]
          }));

          this.updateMapChart(mapData);
        }
      } catch (error) {
        console.error("加载地图数据失败", error);
      }
    },

    // 更新地图（热力图模式）
    updateMapChart(data) {
      if (!this.mapChart) {
        return;
      }

      // 对数变换，避免数据分布极度不均导致大部分省份显示同一颜色
      const formatCount = v => {
        if (!v || v <= 0) {
          return "无数据";
        }
        return v >= 1e8 ? (v / 1e8).toFixed(2) + "亿"
          : v >= 1e4 ? (v / 1e4).toFixed(1) + "万"
            : v;
      };

      // 保存原始值用于 tooltip，value 改为 log10 用于着色
      const logData = data.map(d => ({
        name: d.name,
        value: d.value > 0 ? Math.log10(d.value) : 0,
        rawValue: d.value
      }));

      const logValues = logData.map(d => d.value).filter(v => v > 0);
      const logMin = logValues.length > 0 ? Math.floor(Math.min(...logValues)) : 0;
      const logMax = logValues.length > 0 ? Math.ceil(Math.max(...logValues)) : 8;

      // 生成 visualMap 标签（将 log 刻度转回真实数量级）
      const labelFormatter = logVal => {
        const v = Math.pow(10, logVal);

        return v >= 1e8 ? (v / 1e8).toFixed(0) + "亿"
          : v >= 1e4 ? (v / 1e4).toFixed(0) + "万"
            : v.toFixed(0);
      };

      const option = {
        tooltip: {
          trigger: "item",
          formatter: (params) => {
            const raw = params.data && params.data.rawValue;

            return `${params.name}<br/>请求量: ${formatCount(raw)}`;
          }
        },
        visualMap: {
          min: logMin,
          max: logMax,
          text: ["高", "低"],
          realtime: false,
          calculable: true,
          formatter: labelFormatter,
          inRange: {
            color: ["#313695", "#4575b4", "#74add1", "#abd9e9", "#e0f3f8", "#ffffbf", "#fee090", "#fdae61", "#f46d43", "#d73027", "#a50026"]
          },
          textStyle: {
            color: "#fff"
          },
          bottom: 20,
          left: 20
        },
        geo: {
          map: "china",
          roam: true,
          layoutCenter: ["50%", "62%"],
          layoutSize: "118%",
          itemStyle: {
            areaColor: "#1e3a8a",
            borderColor: "#4da6ff",
            borderWidth: 1
          },
          emphasis: {
            itemStyle: {
              areaColor: "#40a9ff",
              borderColor: "#fff",
              borderWidth: 2
            },
            label: {
              show: true,
              color: "#fff"
            }
          },
          label: {
            show: false
          }
        },
        series: [
          {
            name: "请求量",
            type: "map",
            geoIndex: 0,
            data: logData
          }
        ]
      };

      this.mapChart.setOption(option);
    },

    // 加载劫持事件统计数据
    async loadHijackStatsData() {
      try {
        const res = await getRecHijkcountTab();

        if (res.code === 200) {
          const data = res.data;

          this.hijackStats = {
            eventCount: data.事件数,
            domainCount: data.涉及域名数,
            orgCount: data.涉及机构数
          };

          // node_id 现已是域名而非机构，机构数需通过域名→机构映射接口去重计算
          const domains = data.涉及域名列表 || [];

          if (domains.length) {
            const companyMap = await this.queryDomainCompaniesMap(domains);
            const orgSet = new Set();

            Object.values(companyMap).forEach(list => (list || []).forEach(c => orgSet.add(c)));
            this.hijackStats.orgCount = String(orgSet.size);
          }
        }
      } catch (error) {
        console.error("加载劫持统计数据失败", error);
      }
    },

    // 加载劫持事件列表数据
    async loadHijackEventsData() {
      try {
        const res = await getRecHijkinfoTab();

        if (res.code === 200) {
          const data = res.data;
          const times = data.告警时间 || [];

          this.hijackEventData = times.map((time, index) => {
            const hijackProb = this.normalizeHijackProb((data.hijack_prob || [])[index]);
            return {
              time: time,
              domain: (data.被劫持域名 || [])[index],
              normalIP: (data["解析IP（正常）"] || [])[index] || "—",
              maliciousIP: (data["解析IP（恶意）"] || [])[index] || "—",
              hijackProbText: hijackProb === null ? "无置信度数据" : `${hijackProb.toFixed(1)}%`,
              hijackProbWidth: `${hijackProb || 0}%`,
              hijackProbClass: hijackProb >= 80 ? "high" : hijackProb >= 50 ? "medium" : "low",
              companies: [],
              companiesLoading: true,
              listMetadata: {},
              listMetadataLoading: true,
              status: (data.处置状态 || [])[index] === "已解决" ? "已确认" : (data.处置状态 || [])[index]
            };
          });

          const domains = this.hijackEventData.map(e => e.domain).filter(Boolean);
          const companyResult = this.queryDomainCompaniesMap(domains);
          const listMetadataResult = this.queryDomainListMetadataMap(domains);
          const [companySettled, metadataSettled] = await Promise.allSettled([
            companyResult,
            listMetadataResult
          ]);
          const companyMap = companySettled.status === "fulfilled" ? companySettled.value : {};
          const listMetadataMap = metadataSettled.status === "fulfilled" ? metadataSettled.value : {};
          this.hijackEventData = this.hijackEventData.map(row => {
            const companyKey = getRegistrableDomain(row.domain);
            const metadataKey = (row.domain || "").toLowerCase().replace(/\.$/, "");
            const companies = companyMap[companyKey] || [];

            return {
              ...row,
              companies,
              companiesLoading: false,
              listMetadata: listMetadataMap[metadataKey] || {},
              listMetadataLoading: false
            };
          });
        }
      } catch (error) {
        console.error("加载劫持事件数据失败", error);
      }
    },

    // 批量查询域名→归属机构，机构服务按可注册主域名建立索引。
    async queryDomainCompaniesMap(domains) {
      const merged = {};
      const unique = Array.from(new Set(domains.map(getRegistrableDomain).filter(Boolean)));

      if (!unique.length) {
        return merged;
      }

      const chunkSize = 1000;
      const chunks = [];

      for (let i = 0; i < unique.length; i += chunkSize) {
        chunks.push(unique.slice(i, i + chunkSize));
      }
      try {
        const responses = await Promise.all(chunks.map(c => getDomainCompanyBatch(c)));

        for (const resp of responses) {
          if (resp && resp.result) {
            for (const [domain, companies] of Object.entries(resp.result)) {
              const key = getRegistrableDomain(domain);

              merged[key] = Array.isArray(companies) ? companies : [];
            }
          }
        }
      } catch (e) {
        console.warn("[RecRisk] 劫持事件归属机构查询失败", e.message);
      }
      return merged;
    },

    normalizeHijackProb(value) {
      const num = Number(value);
      if (!Number.isFinite(num)) return null;
      const percent = num <= 1 ? num * 100 : num;
      return Math.max(0, Math.min(100, percent));
    },

    formatListTags(tags) {
      return (tags || []).map(tag => typeof tag === "string" ? tag : (tag.label || tag.name || "")).filter(Boolean).join("、") || "—";
    },

    formatDomainListMetadata,
    formatBestListRank,

    async queryDomainListMetadataMap(domains) {
      const unique = Array.from(new Set(
        domains.map(d => (d || "").toLowerCase().replace(/\.$/, "")).filter(Boolean)
      ));
      if (!unique.length) {
        return {};
      }
      try {
        const res = await getDomainListMetadata(unique);
        return (res && res.items) || {};
      } catch (e) {
        console.warn("[RecRisk] 劫持事件榜单信息查询失败", e.message);
        return {};
      }
    },

    // 导航切换
    handleNavChange(value) {
      if (value === "entitylink") {
        this.$router.push("/entitylink");
      } else if (value === "authrisk") {
        this.$router.push("/authrisk");
      }
    },

    // 启动底部劫持事件表格自动滚动
    startHijackTableScroll() {
      // 每3秒滚动一次
      this.hijackTableScrollTimer = setInterval(() => {
        if (!this.hijackTableScrollPaused && this.$refs.hijackEventTable) {
          const tableBody = this.$refs.hijackEventTable.$el.querySelector(".el-table__body-wrapper");

          if (tableBody) {
            const currentScroll = tableBody.scrollTop;
            const scrollHeight = tableBody.scrollHeight;
            const clientHeight = tableBody.clientHeight;

            // 平滑滚动到下一行（假设每行约50px高度）
            const nextScroll = currentScroll + 50;

            if (nextScroll >= scrollHeight - clientHeight) {
              // 滚动到底部后，回到顶部
              tableBody.scrollTo({ top: 0, behavior: "smooth" });
            } else {
              // 滚动到下一行
              tableBody.scrollTo({ top: nextScroll, behavior: "smooth" });
            }
          }
        }
      }, 3000);
    },

    // 暂停底部表格滚动（鼠标悬停时）
    pauseHijackTableScroll() {
      this.hijackTableScrollPaused = true;
    },

    // 恢复底部表格滚动（鼠标离开时）
    resumeHijackTableScroll() {
      this.hijackTableScrollPaused = false;
    },

    // ============ 机构搜索模式 ============

    // 触发机构搜索
    async handleOrgSearch() {
      if (!this.orgSearchKeyword || !this.orgSearchKeyword.trim()) {
        return;
      }
      this.orgDomainTableData = [];
      this.orgStats = { domainCount: 0, totalQueryCount: 0, activeDomainCount: 0, hijackedDomainCount: 0 };
      this.hasOrgSearched = true;
      this.disposeOverviewCharts();
      await this.$nextTick();
      this.initCharts();
      this.orgLoading = true;
      this.isOrgLoading = true;
      this.orgLoadingStepIndex = 0;
      this.orgLoadingText = this.orgLoadingSteps[0];
      if (this.orgLoadingTimer) {
        clearInterval(this.orgLoadingTimer);
      }
      this.orgLoadingTimer = setInterval(() => {
        this.orgLoadingStepIndex = (this.orgLoadingStepIndex + 1) % this.orgLoadingSteps.length;
        this.orgLoadingText = this.orgLoadingSteps[this.orgLoadingStepIndex];
      }, 800);

      try {
        const keyword = this.orgSearchKeyword.trim();

        // 1. 实体接口：模糊匹配 + 域名列表
        const [entityInfoRes, domainListRes] = await Promise.all([
          getEntityInfo({ 实体名或关键词: keyword }),
          getDomainAuthRiskList({ 实体名或关键词: keyword })
        ]);

        if (
          !(entityInfoRes && entityInfoRes.code === 200)
          || !entityInfoRes.data
          || !(domainListRes && domainListRes.code === 200)
          || !domainListRes.data
          || !(domainListRes.data.域名 || []).length
        ) {
          this.$message.warning("该机构不在监测范围内或暂无域名资产数据");
          this.orgLoading = false;
          return;
        }

        const standardName = entityInfoRes.data.实体规范名称 || keyword;

        this.orgSearchKeyword = standardName;
        this.searchedOrgName = standardName;
        this.hasOrgSearched = true;
        const domains = [...new Set(
          (domainListRes.data.域名 || [])
            .map(d => String(d || "").trim().toLowerCase().replace(/\.$/, ""))
            .filter(Boolean)
        )];

        if (!domains.length) {
          this.$message.info("该机构暂无域名资产数据");
          this.orgLoading = false;
          return;
        }

        // 2. 并发查询每个域名的 flint 解析数据
        const flintMap = await this.loadFlintData(domains);

        this.orgDomainFlintMap = flintMap;

        // 3. 构建表格数据（机构列暂为 loading）
        this.buildOrgDomainTable(domains, flintMap);

        // 4. 渲染柱状图
        this.$nextTick(() => {
          this.updateOrgQueryChart();
        });

        // 5. 异步补充每个域名的归属机构
        this.fetchOrgDomainCompanies(domains);
      } catch (e) {
        console.error("机构搜索失败", e);
        this.$message.error("加载失败：" + (e.message || "网络错误"));
      } finally {
        this.orgLoading = false;
        this.isOrgLoading = false;
        if (this.orgLoadingTimer) {
          clearInterval(this.orgLoadingTimer);
          this.orgLoadingTimer = null;
        }
      }
    },

    // 返回总览
    async backToOverview() {
      this.hasOrgSearched = false;
      this.orgSearchKeyword = "";
      this.searchedOrgName = "";
      this.orgLoading = false;
      this.isOrgLoading = false;
      if (this.orgLoadingTimer) {
        clearInterval(this.orgLoadingTimer);
        this.orgLoadingTimer = null;
      }
      this.orgDomainTableData = [];
      this.orgStats = { domainCount: 0, totalQueryCount: 0, activeDomainCount: 0, hijackedDomainCount: 0 };
      if (this.orgQueryChart) {
        this.orgQueryChart.dispose();
        this.orgQueryChart = null;
      }
      await this.$nextTick();
      this.initCharts();
      this.updateTrendChart(this.trendHistoryData);
      this.updateResponseHistoryChart(this.responseHistoryData);
      this.loadData();
    },

    // 批量补充归属机构
    async fetchOrgDomainCompanies(domains) {
      if (!domains.length) {
        return;
      }
      const merged = await this.queryDomainCompaniesMap(domains);

      this.orgDomainTableData = this.groupRowsByCompanies(this.orgDomainTableData.map(row => ({
        ...row,
        companies: merged[getRegistrableDomain(row.domain)] || [],
        companiesLoading: false
      })));
    },

    // 把同机构的域名相邻摆放：以 companies 排序后 join 作为分组 key，
    // 按各分组首次出现顺序输出；无机构归属的行集中排到最后
    groupRowsByCompanies(rows) {
      const order = new Map();
      const buckets = new Map();
      const empty = [];

      rows.forEach(row => {
        const list = Array.isArray(row.companies) ? row.companies : [];

        if (!list.length) {
          empty.push(row);
          return;
        }
        const key = [...list].sort().join("||");

        if (!order.has(key)) {
          order.set(key, order.size);
          buckets.set(key, []);
        }
        buckets.get(key).push(row);
      });

      const ordered = [];

      [...order.keys()].forEach(key => {
        ordered.push(...buckets.get(key));
      });
      return ordered.concat(empty);
    },

    // 并发（限流 3）查询各域名的 flint 数据
    async loadFlintData(domains) {
      const flintMap = {};
      const CONCURRENCY = 3;

      for (let i = 0; i < domains.length; i += CONCURRENCY) {
        const batch = domains.slice(i, i + CONCURRENCY);
        const results = await Promise.allSettled(
          batch.map(d => queryPassiveDnsFlint(d, "A"))
        );

        results.forEach((r, idx) => {
          flintMap[batch[idx]] = r.status === "fulfilled" ? r.value : [];
        });
      }
      return flintMap;
    },

    // 构建底部域名资产表格 + 更新统计卡片
    buildOrgDomainTable(domains, flintMap) {
      const oneMonthAgo = new Date(Date.now() - 30 * 24 * 3600 * 1000);
      // 从已加载的劫持事件数据中建立被劫持域名集合
      const hijackedSet = {};

      this.hijackEventData.forEach(e => {
        if (e.domain) {
          hijackedSet[e.domain] = (hijackedSet[e.domain] || 0) + 1;
        }
      });

      const rows = domains.map(domain => {
        const records = flintMap[domain] || [];
        const totalCount = records.reduce((s, r) => s + (r.count || 0), 0);
        const ips = new Set();

        records.forEach(r => {
          (r.answers || []).forEach(a => {
            try {
              const obj = typeof a === "string" ? JSON.parse(a) : a;

              if (obj.Data) {
                ips.add(obj.Data);
              }
            } catch (_) {}
          });
        });
        const lastSeen = records.reduce((max, r) => r.last_seen > max ? r.last_seen : max, "");
        const isActive = lastSeen ? new Date(lastSeen) >= oneMonthAgo : false;
        const hijackCount = hijackedSet[domain] || 0;

        return { domain, totalCount, ipCount: ips.size, lastSeen: lastSeen || "-", hijackCount, isActive, companies: null, companiesLoading: true };
      });

      // 排序：被劫持优先，同级按解析量降序
      rows.sort((a, b) => {
        if (b.hijackCount !== a.hijackCount) {
          return b.hijackCount - a.hijackCount;
        }
        return b.totalCount - a.totalCount;
      });

      this.orgDomainTableData = rows;
      this.orgStats = {
        domainCount: rows.length,
        totalQueryCount: rows.reduce((s, r) => s + r.totalCount, 0),
        activeDomainCount: rows.filter(r => r.isActive).length,
        hijackedDomainCount: rows.filter(r => r.hijackCount > 0).length
      };
    },

    // 渲染中间解析量排名柱状图
    updateOrgQueryChart() {
      if (!this.orgQueryChart) {
        return;
      }
      const top = [...this.orgDomainTableData]
        .sort((a, b) => b.totalCount - a.totalCount)
        .slice(0, 15)
        .reverse(); // ECharts 横向柱状图从下往上，reverse 保证最大值在顶

      const labels = top.map(r => r.domain.length > 30 ? r.domain.slice(0, 28) + "…" : r.domain);
      const values = top.map(r => r.totalCount);
      const colors = top.map(r => r.hijackCount > 0 ? "#f5222d" : "#1890FF");

      this.orgQueryChart.setOption({
        tooltip: {
          trigger: "axis",
          axisPointer: { type: "shadow" },
          formatter: params => {
            const d = top[params[0].dataIndex];

            return `${d.domain}<br/>解析量：${d.totalCount.toLocaleString()}${d.hijackCount > 0 ? "<br/><span style=\"color:#f5222d\">⚠ 已劫持</span>" : ""}`;
          }
        },
        grid: { left: "2%", right: "8%", top: "5%", bottom: "5%", containLabel: true },
        xAxis: { type: "value", axisLabel: { color: "#fff", formatter: v => v >= 1e6 ? (v/1e6).toFixed(1)+"M" : v >= 1e3 ? (v/1e3).toFixed(0)+"K" : v }, splitLine: { lineStyle: { color: "rgba(255,255,255,0.1)" } } },
        yAxis: { type: "category", data: labels, axisLabel: { color: "#fff", fontSize: 11 } },
        series: [{
          type: "bar",
          data: values.map((v, i) => ({ value: v, itemStyle: { color: colors[i] } })),
          label: { show: true, position: "right", color: "#fff", formatter: p => p.value >= 1e6 ? (p.value/1e6).toFixed(1)+"M" : p.value >= 1e3 ? (p.value/1e3).toFixed(0)+"K" : p.value }
        }]
      });
      // 图表初始化时容器是 display:none，需要在可见后强制 resize
      this.$nextTick(() => {
        if (this.orgQueryChart) {
          this.orgQueryChart.resize();
        }
      });
    },

    // 域名行样式
    orgDomainRowClass({ row }) {
      return row.hijackCount > 0 ? "hijacked-row" : "";
    },

    // 点击域名行，展示解析历史
    handleOrgDomainClick(row) {
      this.orgSelectedDomain = row.domain;
      const records = (this.orgDomainFlintMap || {})[row.domain] || [];
      // flintMap 存在于 buildOrgDomainTable 之前，需要在 handleOrgSearch 时保存一份

      this.orgSelectedFlintData = records.map(r => {
        const answers = (r.answers || []).map(a => {
          try {
            return (typeof a === "string" ? JSON.parse(a) : a).Data || a;
          } catch (_) {
            return a;
          }
        });

        return { ...r, answersDisplay: answers.join("\n") || "（空）" };
      }).sort((a, b) => b.count - a.count);
      this.orgDomainDialogVisible = true;
    },

    // 数字格式化辅助
    formatCount(n) {
      if (!n) {
        return "0";
      }
      if (n >= 1e8) {
        return (n / 1e8).toFixed(2) + "亿";
      }
      if (n >= 1e4) {
        return (n / 1e4).toFixed(1) + "万";
      }
      return n.toLocaleString();
    }
  }
};
</script>

<style lang="less" scoped>
.rec-risk-container {
  width: 100%;
  min-height: var(--screen-height, 100vh);
  height: var(--screen-height, 100vh);
  background: url("../assets/background.png") no-repeat center center #000;
  background-size: cover;
  position: relative;
  overflow-x: hidden;
  overflow-y: auto;
}

.leftSider, .rightSider {
  position: fixed;
  z-index: 1;
  display: none;

  @media (min-width: 1366px) {
    display: block;
  }

  img {
    height: var(--screen-height, 100vh);
    width: auto;
  }
}

.leftSider {
  left: 0;
  top: 0;
}

.rightSider {
  right: 0;
  top: 0;
}

.main-content {
  position: absolute;
  top: 180px;
  left: 0;
  right: 0;
  bottom: 80px;
  padding: 0 2%;
  z-index: 10;
  overflow-y: scroll;
  scrollbar-gutter: stable;
  overflow-x: hidden;
  box-sizing: border-box;
  width: 100%; // 改用100%而不是100vw

  // 移动端和小屏：单列布局
  display: flex;
  flex-direction: column;
  gap: 15px;

  @media (min-width: 768px) {
    top: 200px;
    padding: 0 4%;
    gap: 20px;
  }

  // 大屏：网格布局（只在足够宽的屏幕上使用grid）
  @media (min-width: 1280px) {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1.5fr) minmax(0, 1fr); // 使用minmax确保严格比例
    grid-template-rows: minmax(calc(var(--screen-height, 100vh) - 700px), 1fr) auto auto;
    grid-template-areas:
      "left center right"
      "bottom bottom bottom"
      "beian beian beian";
    gap: 20px;
  }

  @media (min-width: 1366px) {
    padding: 0 5%; // 使用百分比保持一致性，避免布局重算
  }
}

// 移动端布局调整
.left-section {
  min-width: 0; // 防止内容撑大容器
  max-width: 100%; // 限制最大宽度
  overflow: hidden; // 隐藏溢出内容

  @media (min-width: 1280px) {
    grid-area: left;
  }
}

.center-section {
  min-height: 400px;
  min-width: 0; // 防止内容撑大容器
  max-width: 100%; // 限制最大宽度
  overflow: hidden; // 隐藏溢出内容

  @media (min-width: 1280px) {
    grid-area: center;
  }
}

.right-section {
  min-width: 0; // 防止内容撑大容器
  max-width: 100%; // 限制最大宽度
  overflow: hidden; // 隐藏溢出内容

  @media (min-width: 1280px) {
    grid-area: right;
  }
}

.bottom-section {
  min-width: 0; // 防止内容撑大容器

  @media (min-width: 1280px) {
    grid-area: bottom;
  }
}

.section-card {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 6px;
  padding: clamp(15px, 2vw, 20px);
  padding-bottom: clamp(20px, 3vw, 30px); // 增加底部内边距
  height: 100%;
  width: 100%;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  overflow: hidden;
}

.card-title {
  font-size: clamp(14px, 1.8vw, 18px);
  color: #fff;
  font-weight: bold;
  margin-bottom: 15px;
  min-height: 42px;
  padding-top: 8px;
  padding-bottom: 8px;
  padding-left: 10px;
  line-height: 1.4;
  border-left: 4px solid #1890FF;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .back-button {
    margin-left: auto;
    background: rgba(24, 144, 255, 0.8);
    border-color: #1890FF;
    color: #fff;
    padding: 5px 15px;
    font-size: 12px;

    &:hover {
      background: #1890FF;
      border-color: #40a9ff;
    }
  }

  .subtitle {
    font-size: clamp(12px, 1.5vw, 14px);
    font-weight: normal;
    color: rgba(255, 255, 255, 0.65);
    margin-left: 10px;
    display: inline-block;

    @media (max-width: 768px) {
      display: block;
      margin-left: 0;
      margin-top: 5px;
    }

    .highlight {
      color: #1890FF;
      font-weight: bold;
      font-size: clamp(14px, 1.7vw, 16px);
      margin: 0 3px;
    }
  }
}

.stat-range-tip {
  margin: -4px 0 12px 10px;
  color: rgba(255, 255, 255, 0.58);
  font-size: 12px;
  line-height: 1.4;
}

.map-container {
  width: 100%;
  height: 100%;
  min-height: 350px;

  @media (min-width: 768px) {
    min-height: 400px;
  }
}

.chart-container {
  width: 100%;

  &.trend-chart {
    flex: 1; // 占据剩余空间
    align-self: stretch;
    min-height: 200px; // 最小高度
    max-height: 280px; // 最大高度，防止过大
    margin-top: 20px;
    margin-bottom: 5px; // 底部留出空间
    box-sizing: border-box;
  }

  &.pie-chart {
    height: 250px;
    margin-top: 10px;

    @media (min-width: 768px) {
      height: 280px;
    }
  }

  &.history-chart {
    flex: 1; // 占据剩余空间
    align-self: stretch;
    min-height: 200px; // 最小高度
    max-height: 280px; // 最大高度，防止过大
    margin-top: 20px;
    margin-bottom: 5px; // 底部留出空间
    box-sizing: border-box;
  }
}

// 表格样式
/deep/ .el-table {
  background: transparent;
  color: #fff;
  width: 100% !important;
  table-layout: fixed !important; // 固定布局，强制遵循容器宽度

  th {
    background: rgba(24, 144, 255, 0.1);
    color: #fff;
    font-weight: bold;
    border-color: rgba(255, 255, 255, 0.1);
  }

  td {
    border-color: rgba(255, 255, 255, 0.1);
    color: rgba(255, 255, 255, 0.85);
  }

  tr {
    background: transparent;

    &:hover > td {
      background: rgba(24, 144, 255, 0.1) !important;
      cursor: pointer;
    }
  }

  &::before {
    display: none;
  }

  // 强制表头和表体遵循容器宽度
  .el-table__header-wrapper,
  .el-table__body-wrapper {
    width: 100% !important;
  }

  .el-table__header,
  .el-table__body {
    width: 100% !important;
  }

  // 确保单元格内容正常显示，不强制省略
  .cell {
    white-space: normal; // 允许换行
    word-break: break-word; // 允许单词内换行
    overflow: visible; // 显示所有内容
    text-overflow: clip; // 不使用省略号
  }
}

.status-table,
.response-table {
  margin-bottom: 10px;
  overflow-x: hidden; // 隐藏横向滚动条，强制表格适配容器
  flex-shrink: 0; // 防止表格被压缩
}

.status-table-wrapper,
.response-table-wrapper {
  flex-shrink: 0; // 防止表格容器被压缩
  margin-bottom: 5px;
  height: 220px; // 固定高度，确保两侧对齐
  overflow-y: auto; // 超出高度时显示滚动条

  // 自定义滚动条样式
  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.05);
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(24, 144, 255, 0.3);
    border-radius: 3px;

    &:hover {
      background: rgba(24, 144, 255, 0.5);
    }
  }
}

.org-mode-table-wrapper {
  height: auto;
  min-height: 0;
  overflow-y: visible;

  /deep/ .el-table__body-wrapper {
    overflow-y: visible !important;
    max-height: none !important;
  }
}

.hijack-event-table {
  flex: 1;
  height: 100%;

  // 该表格不支持点击查看详情，覆盖表格通用的手型光标
  /deep/ tr:hover > td {
    cursor: default;
  }

  /deep/ .el-table__body-wrapper {
    max-height: 250px;
    overflow-y: auto;
    overflow-x: auto;

    // 自定义滚动条样式
    &::-webkit-scrollbar {
      width: 6px;
      height: 6px;
    }

    &::-webkit-scrollbar-track {
      background: rgba(255, 255, 255, 0.05);
      border-radius: 3px;
    }

    &::-webkit-scrollbar-thumb {
      background: rgba(24, 144, 255, 0.3);
      border-radius: 3px;

      &:hover {
        background: rgba(24, 144, 255, 0.5);
      }
    }
  }
}

// 底部栏目特殊样式
.bottom-card {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.bottom-content {
  flex: 1;
  display: flex;
  gap: 20px;
  min-height: 0; // 重要：允许flex子项收缩

  @media (max-width: 768px) {
    flex-direction: column;
  }
}

// 左侧统计面板
.stats-panel {
  flex: 0 0 450px; // 固定宽度450px
  background: linear-gradient(135deg, rgba(24, 144, 255, 0.1), rgba(0, 212, 255, 0.05));
  border: 1px solid rgba(24, 144, 255, 0.3);
  border-radius: 8px;
  padding: 20px;
  display: flex;
  flex-direction: column; // 纵向：标题在上，统计项在下
  gap: 15px;

  @media (max-width: 1280px) {
    flex: 0 0 auto; // 中等屏幕自适应
  }

  @media (max-width: 768px) {
    flex: 1 0 auto; // 小屏占满
  }

  .stats-title {
    font-size: 16px;
    font-weight: bold;
    color: #fff;
    text-align: center;
    padding-bottom: 15px;
    border-bottom: 2px solid rgba(24, 144, 255, 0.5);
  }

  .stats-items-wrapper {
    display: flex;
    flex-direction: column; // 纵向排布三个统计项
    gap: 12px;
  }

  .stats-item {
    display: flex;
    flex-direction: row; // 横向：标题在左，数字在右
    align-items: center;
    justify-content: space-between; // 两端对齐
    padding: 12px 20px;
    background: rgba(0, 0, 0, 0.2);
    border-radius: 6px;
    transition: all 0.3s ease;

    &:hover {
      background: rgba(24, 144, 255, 0.15);
      transform: translateX(5px);
      box-shadow: 0 4px 12px rgba(24, 144, 255, 0.2);
    }

    .stats-label {
      font-size: 14px;
      color: rgba(255, 255, 255, 0.7);
      white-space: nowrap;
    }

    .stats-value {
      display: flex;
      align-items: baseline;
      gap: 5px;

      .number {
        font-size: 24px;
        font-weight: bold;
        color: #1890FF;
        line-height: 1;
      }

      .unit {
        font-size: 14px;
        color: rgba(255, 255, 255, 0.65);
      }
    }
  }
}

// 右侧事件面板
.events-panel {
  flex: 1;
  min-width: 0; // 重要：允许flex子项收缩
  display: flex;
  flex-direction: column;
}

/deep/ .el-tag {
  &.el-tag--danger {
    background-color: rgba(245, 34, 45, 0.2);
    border-color: #F5222D;
    color: #F5222D;
  }

  &.el-tag--success {
    background-color: rgba(82, 196, 26, 0.2);
    border-color: #52C41A;
    color: #52C41A;
  }
}

// ---- 机构搜索 Header（与权威侧统一） ----
.page-update-time {
  position: absolute;
  top: 118px;
  right: 5%;
  z-index: 12;
  color: rgba(255, 255, 255, 0.82);
  font-size: 14px;
  line-height: 1;
  padding: 8px 12px;
  border: 1px solid rgba(126, 214, 255, 0.32);
  border-radius: 6px;
  background: rgba(7, 18, 49, 0.58);
  box-shadow: 0 6px 18px rgba(0, 18, 56, 0.2);
}

.org-search-panel {
  width: min(760px, calc(100% - 64px));
  margin: 14px auto 18px;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 12px 10px 18px;
  border: 1px solid rgba(126, 214, 255, 0.36);
  border-radius: 8px;
  background: linear-gradient(90deg, rgba(17, 32, 78, 0.92), rgba(25, 59, 111, 0.74));
  box-shadow: 0 10px 28px rgba(0, 18, 56, 0.26), inset 0 0 20px rgba(61, 173, 255, 0.08);

  /deep/ .el-autocomplete {
    flex: 1;
  }

  /deep/ .el-input__inner {
    background-color: rgba(7, 18, 49, 0.72);
    border: 1px solid rgba(126, 214, 255, 0.48);
    border-right: none;
    color: #fff;
    font-size: 14px;
    height: 38px;
    &::placeholder { color: rgba(255, 255, 255, 0.56); }
  }

  /deep/ .el-input-group__append {
    background: linear-gradient(135deg, rgba(21, 126, 251, 0.92), rgba(35, 198, 255, 0.84));
    border: 1px solid rgba(126, 214, 255, 0.55);
    border-left: none;
    color: #fff;
    padding: 0 14px;
  }

  /deep/ .el-input__suffix {
    right: 54px;
  }

  .back-overview-btn {
    flex: 0 0 auto;
    font-size: 13px;
    height: 36px;
    padding: 0 14px;
    background: rgba(250, 140, 22, 0.9);
    border-color: #fa8c16;
    color: #fff;

    &:hover {
      background: #fa8c16;
      border-color: #ffa940;
    }
  }
}

@media (max-width: 768px) {
  .page-update-time {
    top: 106px;
    right: 14px;
    font-size: 12px;
    padding: 6px 8px;
  }

  .org-search-panel {
    width: calc(100% - 28px);
    flex-direction: column;
    align-items: stretch;
    padding: 10px;
    margin-top: 10px;

    .back-overview-btn {
      width: 100%;
    }
  }
}

// ---- 机构模式中间柱状图 ----
.org-query-chart {
  flex: 1;
  min-height: 320px;
  width: 100%;
}
.org-loading-tip {
  color: rgba(255, 255, 255, 0.5);
  font-size: 13px;
  text-align: center;
  padding: 40px 0;
}

// ---- 机构模式底部域名资产表格 ----
.org-domain-table {
  /deep/ .hijacked-row td {
    background: rgba(245, 34, 45, 0.06) !important;
  }
  /deep/ .clickable-row {
    cursor: pointer;
  }
}
.hijack-highlight {
  color: #f5222d !important;
}

// ---- 解析历史弹窗 ----
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;

  .loading-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
  }

  .loading-dots {
    display: flex;
    gap: 10px;

    span {
      width: 12px;
      height: 12px;
      background: #1890FF;
      border-radius: 50%;
      animation: loading-bounce 1.4s infinite ease-in-out both;

      &:nth-child(1) { animation-delay: -0.32s; }
      &:nth-child(2) { animation-delay: -0.16s; }
      &:nth-child(3) { animation-delay: 0s; }
    }
  }

  .loading-text {
    color: #fff;
    font-size: 14px;
    opacity: 0.85;
    font-family: monospace;
    letter-spacing: 0.05em;
  }
}

@keyframes loading-bounce {
  0%, 80%, 100% { transform: scale(0); }
  40% { transform: scale(1); }
}

// ---- 解析历史弹窗 ----
/deep/ .domain-detail-dialog {
  z-index: 1200;

  .el-dialog {
    background: #0d1b2e;
    border: 1px solid rgba(24, 144, 255, 0.3);
  }
  .el-dialog__title { color: #fff; }
  .el-dialog__headerbtn .el-dialog__close { color: #fff; }
}
.flint-table {
  /deep/ .el-table__header th { background: rgba(24, 144, 255, 0.1); color: #fff; }
  /deep/ .el-table__row td { color: rgba(255,255,255,0.85); background: transparent; }
  /deep/ .el-table__body tr:hover td { background: rgba(24,144,255,0.1) !important; }
}

.company-tag {
  display: inline-block;
  padding: 1px 8px;
  margin: 2px 4px 2px 0;
  border-radius: 10px;
  font-size: 11px;
  background: rgba(96,165,250,0.14);
  color: #bfdbfe;
  border: 1px solid rgba(96,165,250,0.3);
}
.muted { color: rgba(255,255,255,0.45); font-size: 12px; }
.list-tags-preview { color: #bfdbfe; }
.hijack-confidence-bar {
  width: 100%;
  height: 10px;
  overflow: hidden;
  border-radius: 5px;
  background: rgba(255,255,255,0.12);
}
.hijack-confidence-fill {
  display: block;
  height: 100%;
  border-radius: 5px;
  &.high { background: linear-gradient(90deg, #ff7875, #f5222d); }
  &.medium { background: linear-gradient(90deg, #ffc53d, #fa8c16); }
  &.low { background: linear-gradient(90deg, #69c0ff, #1890ff); }
}

.beian-footer {
  grid-area: beian;
  justify-self: stretch;
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
  flex: 0 0 auto;
  align-self: stretch;
  position: relative;
  z-index: 20;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #5f6f89;
  font-size: 13px;
  margin: 180px 0 0;
  padding: 0 0 120px;
}

.beian-footer a {
  color: #5f6f89;
  text-decoration: none;
}

.beian-footer a:hover {
  color: #1f78ff;
}

.beian-police-link {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.beian-police-logo {
  width: 16px;
  height: 16px;
  object-fit: contain;
}
</style>
